import { withParams, req } from './common'
export default withParams({ type: 'required' }, req)



// WEBPACK FOOTER //
// ./src/assets/validity/validators/required.js